//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { PojoSet } from 'pojo-sets';

import { RequestRightsNonMentionedModalAction } from '@galleries/actions/requestRightsNonMentionedModalActions';
import { REQUEST_RIGHTS_MODAL_NON_MENTIONED_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IRequestRightsNonMentionedModalState } from '@galleries/models/requestRightsNonMentionedModalModel';

export const initialState: IRequestRightsNonMentionedModalState = {
  isOpen: false,
  selectedIndex: 0,
  materializedItems: [],
  currentlyRequestingRights: {},
  rightsFailed: {},
  rightsPending: {},
};

export default (
  state: IRequestRightsNonMentionedModalState = initialState,
  action: RequestRightsNonMentionedModalAction,
): IRequestRightsNonMentionedModalState => {
  switch (action.type) {
    case REQUEST_RIGHTS_MODAL_NON_MENTIONED_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
        materializedItems: action.materializedItems,
      };

    case REQUEST_RIGHTS_MODAL_NON_MENTIONED_ACTIONS.CLOSE_MODAL:
      return initialState;

    case REQUEST_RIGHTS_MODAL_NON_MENTIONED_ACTIONS.SET_SELECTED_INDEX:
      return {
        ...state,
        selectedIndex: action.selectedIndex,
      };

    case REQUEST_RIGHTS_MODAL_NON_MENTIONED_ACTIONS.REQUEST_RIGHTS:
      return {
        ...state,
        currentlyRequestingRights: PojoSet.add(
          state.currentlyRequestingRights,
          action.itemId,
        ),
      };

    case REQUEST_RIGHTS_MODAL_NON_MENTIONED_ACTIONS.REQUEST_RIGHTS_SUCCEEDED:
      return {
        ...state,
        currentlyRequestingRights: PojoSet.remove(
          state.currentlyRequestingRights,
          action.itemId,
        ),
        rightsPending: PojoSet.add(state.rightsPending, action.itemId),
      };

    case REQUEST_RIGHTS_MODAL_NON_MENTIONED_ACTIONS.REQUEST_RIGHTS_FAILED:
      return {
        ...state,
        currentlyRequestingRights: PojoSet.remove(
          state.currentlyRequestingRights,
          action.itemId,
        ),
        rightsFailed: PojoSet.add(state.rightsFailed, action.itemId),
      };

    default:
      return state;
  }
};
